import { EsiFeeScheduleType, useGetEsiFeeSchedulesQuery } from '../../types';

export interface UseEsiFeeScheduleQueriesResult {
  rows: EsiFeeScheduleType[];
  loading: boolean;
  hasError: boolean;
}

const EMPTY_ROWS: EsiFeeScheduleType[] = [];

export const useEsiFeeScheduleQueries = (): UseEsiFeeScheduleQueriesResult => {
  const { data, loading, error } = useGetEsiFeeSchedulesQuery();

  return {
    rows: data?.getEsiFeeSchedules ?? EMPTY_ROWS,
    loading,
    hasError: !!error,
  };
};
